<template>
  <v-alert
    id="alert"
    color="#C51162"
    dark
    icon="mdi-alert-circle"
    border="left"
    prominent
    :value="Boolean(error.name)"
    transition="fade-transition"
    dismissible
    dense
    @input="hide"
    class="e-alert"
  >
    <v-expansion-panels class="e-alert__content">
      <v-expansion-panel>
        <v-expansion-panel-header>{{ error.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <span style="font-weight: bold">{{ error.message }}</span>
          <div style="word-break: break-word" class="text-pre-wrap" v-if="error.debugInfo">{{ error.debugInfo }}</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useErrorStore } from '@/pinia/helpers';
import store from '@/store';

const errorStore = useErrorStore();

const error = computed(() => {
  return errorStore.error.message ? errorStore.error : store.getters.error;
});

function hide() {
  errorStore.clearError();
  store.commit('clearStore');
}
</script>

<style scoped lang="scss">
@use 'src/assets/style/mixins.scss' as *;

.e-alert {
  z-index: 999 !important;
  position: fixed;
  bottom: 20px;
  right: 10px;
  min-width: 300px;

  @include mobile {
    min-width: 200px !important;
  }

  &:deep(.v-alert__dismissible) {
    background: transparent !important;
  }

  &:deep(.theme--dark.v-expansion-panels .v-expansion-panel) {
    background-color: rgba(0, 0, 0, 0) !important;
  }

  &__content {
    min-width: 290px !important;

    @include mobile {
      min-width: 200px !important;
    }
  }
}
</style>
